import { getTournamentLeaderboardEntries } from '../../modules/tournament_api';

const schema = {
  allPlayers: {
    typeId: 1,
    title: 'All Players',
    columns: [
      {
        id: 'rank',
        display: 'Rank',
      },
      {
        id: 'organization_name',
        display: 'Facility',
      },
      {
        id: 'player_name',
        display: 'Player Name',
      },
      {
        id: 'score',
        display: 'Score',
      },
    ],
  },
  facility: {
    typeId: 2,
    title: 'My Facility Leaderboard',
    columns: [
      {
        id: 'rank',
        display: 'Rank',
      },
      {
        id: 'player_name',
        display: 'Player Name',
      },
      {
        id: 'score',
        display: 'Score',
      },
    ],
  },
  tournament: {
    typeId: 3,
    title: 'Tournament Leaderboard',
    columns: [
      {
        id: 'rank',
        display: 'Rank',
      },
      {
        id: 'organization_name',
        display: 'Facility',
      },
      {
        id: 'score',
        display: 'Score',
      },
    ],
  },
};

const filterEntries = (entries, columns, page) =>
  entries.map((entry, index) =>
    columns.map((column) => {
      const rank = page * 10 + index + 1;
      return column.id === 'rank' ? rank : entry[column.id];
    })
  );

export const getAllEntries = async (tournamentId) => {
  return Promise.all([
    getTournamentLeaderboardEntries(tournamentId, 1, 0, false),
    getTournamentLeaderboardEntries(tournamentId, 2, 0, false),
    getTournamentLeaderboardEntries(tournamentId, 3, 0, false),
  ]).then((entries) => {
    const [playerEntries, facilityEntries, tournamentEntries] = entries;

    return [
      {
        ...schema.allPlayers,
        standings: filterEntries(playerEntries.data.entries, schema.allPlayers.columns, 0),
        count: playerEntries.data.count,
        page: 0,
      },
      {
        ...schema.facility,
        standings: filterEntries(facilityEntries.data.entries, schema.facility.columns, 0),
        count: facilityEntries.data.count,
        page: 0,
      },
      {
        ...schema.tournament,
        standings: filterEntries(tournamentEntries.data.entries, schema.tournament.columns, 0),
        count: tournamentEntries.data.count,
        page: 0,
      },
    ];
  });
};

export const getEntry = async (tournamentId, typeId, page = 0, daily = false) => {
  const workingSchema = typeId === 1 ? schema.allPlayers : typeId === 2 ? schema.facility : schema.tournament;

  return getTournamentLeaderboardEntries(tournamentId, typeId, page, daily).then((results) => {
    return {
      ...workingSchema,
      standings: filterEntries(results.data.entries, workingSchema.columns, page),
      count: results.data.count,
      page,
    };
  });
};
